export interface CatalogItem {
    item_id: string;
    parent_id: string;
    item_name: string;
    item_description: string | null;
    item_images?: Array<{
        item_image_id?: string;
        file_id?: string;
        display_order?: number;
        image?: object;
    }>;
    total_units: number;
    unit_price: string | null;
    currency_id: string | null;
    division_id: string | null;
    division_name: string | null;
    supplier_id: string | null;
    hidden: number;
    date_created: string | null;
    status: string | null;
    ext_product_id: string | null;
    supplier_code: string | null;
    copied_from: string | null;
    sage_id: string | null;
    promo_api_name: string | null;
    has_item_locations: boolean;
}

export const CATALOG_ITEMS_SORT_FIELDS = [
    "item_name",
    "division_name",
    "status",
    "is_upgradeable",
] as const;

export type CatalogItemsSortField = (typeof CATALOG_ITEMS_SORT_FIELDS)[number];

export function buildCatalogItemsSortParam(
    field: CatalogItemsSortField,
    direction: "asc" | "desc",
): string {
    return direction === "desc" ? `-${field}` : field;
}

export function parseCatalogItemsSortParam(
    param: string | null,
): { field: CatalogItemsSortField; direction: "asc" | "desc" } | null {
    if (!param?.trim()) {
        return null;
    }
    const trimmed = param.trim();
    if (trimmed.startsWith("-")) {
        const field = trimmed.slice(1);
        if (!CATALOG_ITEMS_SORT_FIELDS.includes(field as CatalogItemsSortField)) {
            return null;
        }
        return { field: field as CatalogItemsSortField, direction: "desc" };
    }
    if (!CATALOG_ITEMS_SORT_FIELDS.includes(trimmed as CatalogItemsSortField)) {
        return null;
    }
    return { field: trimmed as CatalogItemsSortField, direction: "asc" };
}

export function nextCatalogItemsSortParam(
    current: string | null,
    field: CatalogItemsSortField,
): string {
    const parsed = parseCatalogItemsSortParam(current);
    if (!parsed || parsed.field !== field) {
        return buildCatalogItemsSortParam(field, "asc");
    }
    return buildCatalogItemsSortParam(field, parsed.direction === "asc" ? "desc" : "asc");
}
